import React from "react";
import classes from "./SwipeRecap.module.css"
import clsx from "clsx";
import { observer } from "mobx-react-lite";
import { BsFillSuitDiamondFill } from "react-icons/bs";

const SwipeRecap = ({instance}) => {

  const debrief = instance.getDebrief()

  return (
    <div className={classes.SwipeRecap}>

      {instance.Propositions.map(p => {

        return (
        <div className={classes.proposition_recap} key={p.ID}>
          <div className={classes.texts}>
            <div className={classes.text}>{p.Text}</div>
            {p.Debrief && <div className={classes.minidebrief}>{p.Debrief}</div>}
          </div>
          <div className={classes.answers}>

            <div className={clsx(
              classes.choice,
              !p.isCorrect && p.userIsCorrect && classes.correctChoice,
              !p.isCorrect && !p.userIsCorrect && classes.missedChoice,
              p.isCorrect && !p.userIsCorrect && classes.incorrectChoice,
            )}>

              {p.incorrectText}

              {/* <div className={classes.pawns}>
                {p.userAnswer === false && <BsFillSuitDiamondFill style={{color: AppState.plateau.myPlayer.Color}} />}
              </div> */}
            </div>


            <div className={clsx(
              classes.choice,
              p.isCorrect && p.userIsCorrect && classes.correctChoice,
              p.isCorrect && !p.userIsCorrect && classes.missedChoice,
              !p.isCorrect && !p.userIsCorrect && classes.incorrectChoice,
            )}>
              {p.correctText}
            </div>

          </div>
        </div>)
      })}

    </div>
  )
}

export default observer(SwipeRecap)